module.exports = __webpack_public_path__ + "static/media/halloween11.486f83e6.webp";